import { z } from 'zod';
import { FlowIteratorBlockErrorResolution } from './errorResolution.js';
import { FlowDurationSchema } from '../../../../duration/duration.js';
import { FlowProducedType } from '../../../../flowRun/producedType.js';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowLlmPromptBlockBaseSchema } from '../../llmPrompt/config.js';
import { FlowRestBlockBaseSchema } from '../../rest/config.js';
import { FlowScriptedBlockBaseSchema } from '../../script/config.js';
import { FlowSubflowV1BlockBaseSchema } from '../../subflow/v1/config.js';
import { FlowBlockType } from '../../type.js';
/**
 * The REST and sub-flow members are structural only; flow-api replaces this union with the variant
 * whose members also run their database-backed checks.
 */
export const FlowIteratorV1AllowedActionBlockSchema = z.discriminatedUnion('type', [
    FlowLlmPromptBlockBaseSchema,
    FlowScriptedBlockBaseSchema,
    FlowRestBlockBaseSchema,
    FlowSubflowV1BlockBaseSchema,
    // Add other block types here
]);
export const FlowIteratorV1BlockConfigSchema = z.object({
    /**
     * A list of items to iterate: run {@link action} for each item
     */
    items: z.string().or(z.array(z.unknown())),
    /**
     * (Optional) a top-level field in the {@link items} array of objects to use as the unique id for items
     */
    itemKey: z.string().optional(),
    /**
     * The lambda action to execute for each entry in the list
     */
    action: FlowIteratorV1AllowedActionBlockSchema,
    /**
     * Action to take when an error occurs during the {@link action} for a single item in the list
     */
    errorResolution: z.enum(FlowIteratorBlockErrorResolution),
    /**
     * (Optional) A duration to wait between each item in the list
     */
    iterationStepDuration: FlowDurationSchema.optional(),
});
export const FlowIteratorV1BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.IteratorV1),
    config: FlowIteratorV1BlockConfigSchema,
    returnType: z.literal(FlowProducedType.Any).default(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map